import { render, staticRenderFns } from "./setPrice.vue?vue&type=template&id=e240fa16&scoped=true&"
import script from "./setPrice.vue?vue&type=script&lang=js&"
export * from "./setPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e240fa16",
  null
  
)

export default component.exports